/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ListEscalationTicketsRequest} from '@cash-web/protos/squareup/privacyvault/service.pb'
import {ListEscalationTicketsResponse} from '@cash-web/protos/squareup/privacyvault/service.pb'


export const listEscalationTickets = (request: ListEscalationTicketsRequest, options?: CashRequestOptions) => post<ListEscalationTicketsRequest, ListEscalationTicketsResponse>("/2.0/cash/list-escalation-tickets", request, {...options, rejectOnError: true })